import { gql } from '@apollo/client'

export const EDIT_PAYEES_MUTATION = gql`
  mutation updateBillpayPayee(
    $appName: AppNameEnum
    $payeeUpdateRequest: BillpayPayeeUpdateRequest
  ) {
    updateBillpayPayee(
      appName: $appName
      payeeUpdateRequest: $payeeUpdateRequest
    ) {
      payee {
        payeeId
        payeeStatus
        lastUpdatedDate
      }
    }
  }
`
export default EDIT_PAYEES_MUTATION
